import { Fragment, useEffect, useRef } from 'react';
import styled from 'styled-components';
import Edition from '../../services/Edition';
import Socials from './Socials';
import Buttons from './Buttons';
import SLPBranding from './SLPBranding';
import Avatar from './Avatar';
import DisplayName from './DisplayName';
import Description from './Description';
import ShareButtons from './ShareButtons';
import CookieConsent from './CookieConsent';
import Rellax from 'rellax';

import EmailModal from './Modal/Email';
import ImagegalleryModal from './Modal/Imagegallery';
import ModalModal from './Modal/Modal';
import { useQuery } from '../../services/Util';

import * as IconsOutline from './Socials/icons/outline/index';
import * as IconsSolid from './Socials/icons/solid/index';
import MailchimpModal from './Modal/Mailchimp';

export default function Render({ page, isPreview }) {
	const rellaxRef = useRef();

	const query = useQuery();

	// https://stackoverflow.com/a/61887298/38241
	useEffect(() => {
		if ('1' !== page.backgroundParallax) {
			if (rellaxRef.current) {
				rellaxRef.current.destroy();
			}
			return false;
		}

		rellaxRef.current = new Rellax('#slp-background-media img', {
			speed: -5,
			center: true,
			wrapper: '#slp-Render',
		});
	}, [page.backgroundParallax]);

	function buttonOnClickTrack(e, buttonId) {
		if (e) {
			e.preventDefault();
		}

		window.jQuery.post(window.social_link_pages.admin_ajax, {
			action: 'social_link_pages_button_click',
			button_id: buttonId,
			page_id: page.id,
			_wpnonce: document.getElementById('social_link_pages_wpnonce').value,
		});

		if (e && e.target && e.target.getAttribute('href')) {
			const url = e.target.getAttribute('href');
			setTimeout(() => {
				window.open(url, '_blank');
			}, 300);
		}
	}

	if (!page.buttons) {
		page.buttons = [];
	}

	const renderShareButtons = !Edition.isDefault &&
		page.shareButtonsPosition &&
		page.shareButtonsPosition.length > 0 && (
			<ShareButtons
				backgroundColor={page.backgroundColor}
				textColor={page.textColor}
				slug={page.slug}
				iconStyle={page.iconStyle}
				position={page.shareButtonsPosition}
			/>
		);

	const showSLPBranding = !isPreview && (Edition.isDefault || !page.disable_slp_branding);

	let backgroundImage = page.backgroundImage || '';
	backgroundImage =
		'avatar' === page.backgroundMediaStyle && page.avatar && page.avatar.length > 0
			? page.avatar
			: backgroundImage;

	let videoAspectRatio =
		page.backgroundVideoAspectRatio && page.backgroundVideoAspectRatio.length > 0
			? parseFloat(page.backgroundVideoAspectRatio)
			: 1.778;

	return (
		<Fragment>
			<StyledRender {...page} isPreview={isPreview} id="slp-Render">
				{page.backgroundMediaStyle && page.backgroundMediaStyle.length > 0 && (
					<div
						id="slp-background-media"
						style={
							'' === page.backgroundCover &&
							('avatar' === page.backgroundMediaStyle || 'image' === page.backgroundMediaStyle)
								? { backgroundImage: `url(${backgroundImage})` }
								: null
						}
					>
						{'' !== page.backgroundCover &&
							('image' === page.backgroundMediaStyle || 'avatar' === page.backgroundMediaStyle) && (
								<img src={backgroundImage} className="rellax" />
							)}
						{'video' === page.backgroundMediaStyle &&
							page.backgroundVideoHtml &&
							page.backgroundVideoHtml.length > 0 && (
								<StyledBackgroundVideoWrapper
									videoAspectRatio={videoAspectRatio}
									dangerouslySetInnerHTML={{
										__html: page.backgroundVideoHtml,
									}}
								></StyledBackgroundVideoWrapper>
							)}
					</div>
				)}

				<div id="slp-Header">{'bottom' !== page.shareButtonsPosition && renderShareButtons}</div>

				<Avatar
					avatar={page.avatar}
					avatarBorder={page.avatarBorder}
					avatarShape={page.avatarShape}
					avatarLink={page.avatarLink}
					backgroundHeader={'header' === page.backgroundCover}
				/>
				<DisplayName
					displayName={page.displayName}
					displayNameFontSize={page.displayNameFontSize}
				/>
				<Description description={page.description} />

				{'top' === page.socialsPosition ? (
					<>
						<Socials
							pageId={page.id}
							buttons={page.buttons}
							iconStyle={page.iconStyle}
							socialsBorder={page.socialsBorder}
							onClick={buttonOnClickTrack}
						/>
						<Buttons pageId={page.id} buttons={page.buttons} onClick={buttonOnClickTrack} />
					</>
				) : (
					<>
						<Buttons
							isPreview={isPreview}
							pageId={page.id}
							buttons={page.buttons}
							onClick={buttonOnClickTrack}
						/>
						<Socials
							pageId={page.id}
							buttons={page.buttons}
							iconStyle={page.iconStyle}
							socialsBorder={page.socialsBorder}
							onClick={buttonOnClickTrack}
						/>
					</>
				)}

				<div id="slp-Footer">{'bottom' === page.shareButtonsPosition && renderShareButtons}</div>

				{showSLPBranding && (
					<SLPBranding backgroundColor={page.backgroundColor} textColor={page.textColor} />
				)}

				{page.showCookieConsent && '1' === String(page.showCookieConsent) && (
					<CookieConsent
						isPreview={isPreview}
						cookieConsentMessage={page.cookieConsentMessage}
						FacebookPixel={page.FacebookPixel}
						GoogleAnalytics={page.GoogleAnalytics}
					/>
				)}

				{'email' === query.get('m') && <EmailModal page={page} />}
				{'image' === query.get('m') && <ImagegalleryModal />}
				{'modal' === query.get('m') && <ModalModal page={page} />}
				{'mailchimp' === query.get('m') && <MailchimpModal page={page} />}
			</StyledRender>

			{page.customCss && page.customCss.length && (
				<style
					dangerouslySetInnerHTML={{
						__html: page.customCss,
					}}
				/>
			)}
		</Fragment>
	);
}

const StyledRender = styled.div`
	height: 100%;
	overflow-x: hidden;
	overflow-y: auto;
	padding-bottom: 2rem;
	position: relative;

	background-color: rgb(${(props) => props.backgroundColor || '256, 256, 256'});
	${(props) =>
		'gradient' === props.backgroundStyle && props.backgroundGradient
			? `background: ${props.backgroundGradient};`
			: ''}

	* {
		color: rgb(${(props) => props.textColor || '0,0,0'});
		font-family: ${(props) => props.font || ''};
	}

	audio {
		border-radius: 2rem;
		width: 100%;
	}

	#slp-background-media {
		${(props) => ('avatar' === props.backgroundMediaStyle ? 'filter: blur(20px);' : '')}
		height: ${(props) => ('header' === props.backgroundCover ? '33%' : '100%')};
		overflow: hidden;
		pointer-events: none;
		position: fixed;
		width: 100%;
		z-index: 0;
		left: 0;
		top: 0;

		// video {
		// 	width: 100% !important;
		// 	height: auto !important;
		// }
		//

		img {
			position: absolute;
			width: 100%;
			height: 100%;
			object-fit: cover;
			${(props) => ('1' === props.backgroundParallax ? 'transform: scale(1.2);' : '')}
		}
	}

	#slp-avatar {
		${(props) => ('header' === props.backgroundCover ? 'margin-top: 22%;' : '')}
	}

	.modal-content {
		background-color: rgb(${(props) => props.backgroundColor || '256, 256, 256'});
		color: rgb(${(props) => props.textColor || '0,0,0'});
		font-family: ${(props) => props.font || ''};
	}
	// .form-control,
	// .modal-content .btn
	// {
	// 	color: rgb(${(props) => props.backgroundColor || ''});
	// 	background-color: rgb(${(props) => props.textColor || ''});
	// 	border-color: rgb(${(props) => props.backgroundColor || ''});
	// }

	#slp-Header,
	#slp-Footer {
		padding-top: 1rem;
		position: sticky;
		text-align: center;
	}

	#slp-Header {
		padding-bottom: 1rem;
		top: 0;
	}

	#slp-Footer {
		bottom: 0;
		padding-top: 1rem;

		a {
			color: rgb(${(props) => props.textColor || '256, 256, 256'});
		}
	}

	.container {
		max-width: 600px;
		position: relative;
		z-index: 1;
	}

	.slp-iframe-wrapper {
		display: block; /* Needed for span. */
		position: relative;
		overflow: hidden;
		width: 100%;
		padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */

		iframe {
			border: 0;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			width: 100%;
			height: 100%;
		}
	}

	.slp-Section {
		margin-bottom: ${(props) => (props.sectionSpacing ? props.sectionSpacing : '1')}rem;
	}

	.btn {
		align-content: center;
		display: flex;
		justify-content: center;
		${(props) => {
			if (props.buttonBackgroundColor && props.buttonBackgroundColor.length > 0) {
				return `background-color: rgba(${props.buttonBackgroundColor});`;
			}
		}}
		color: rgb(
			${(props) => {
			if (props.buttonTextColor && props.buttonTextColor.length > 0) {
				return props.buttonTextColor;
			}
			return props.textColor ? props.textColor : '0, 0, 0';
		}}
		);
		border-color: rgb(
			${(props) => {
				if (props.buttonBorderColor && props.buttonBorderColor.length > 0) {
					return props.buttonBorderColor;
				}
				if (props.buttonTextColor && props.buttonTextColor.length > 0) {
					return props.buttonTextColor;
				}
				return props.textColor ? props.textColor : '0, 0, 0';
			}}
		);
		border-radius: ${(props) => (props.buttonBorderRadius ? props.buttonBorderRadius : '.382')}rem;

		&:hover,
		&:focus,
		&:active {
			outline: none;
			${(props) => {
				if (props.buttonHoverBackgroundColor && props.buttonHoverBackgroundColor.length > 0) {
					return `background-color: rgba(${props.buttonHoverBackgroundColor});`;
				}
				if (props.buttonTextColor && props.buttonTextColor.length > 0) {
					return `background-color: rgba(${props.buttonTextColor});`;
				}
				return `background-color: rgba(${props.textColor ? props.textColor : '256, 256, 256'});`;
			}}
			color: rgb(
				${(props) => {
				if (props.buttonHoverTextColor && props.buttonHoverTextColor.length > 0) {
					return props.buttonHoverTextColor;
				}
				if (props.buttonBackgroundColor && props.buttonBackgroundColor.length > 0) {
					return props.buttonBackgroundColor;
				}
				return props.backgroundColor ? props.backgroundColor : '0, 0, 0';
			}}
			);

			svg {
				fill: rgb(
					${(props) => {
						if (props.buttonHoverTextColor && props.buttonHoverTextColor.length > 0) {
							return props.buttonHoverTextColor;
						}
						if (props.buttonBackgroundColor && props.buttonBackgroundColor.length > 0) {
							return props.buttonBackgroundColor;
						}
						return props.backgroundColor ? props.backgroundColor : '0, 0, 0';
					}}
				);
			}
		}

		svg {
			height: 2em;
			width: 2em;
			overflow: visible;
			pointer-events: none;
			${(props) => (props.textColor ? 'fill: rgb(' + props.textColor + ');' : '')}
			${(props) => (props.textColor ? 'stroke: rgb(' + props.textColor + ');' : '')}
		}
	}

	.forever {
		animation-iteration-count: infinite !important;
	}

	.wiggle {
		animation-duration: 2.5s;
		animation-timing-function: ease-in-out;
		animation-delay: 0s;
		animation-iteration-count: 2;
		animation-direction: normal;
		animation-fill-mode: none;
		animation-play-state: running;
		animation-name: wiggle;

		&:hover,
		&:focus,
		&:active {
			animation: none;
		}
	}

	@keyframes wiggle {
		0% {
			transform: rotate(0deg);
		}
		80% {
			transform: rotate(0deg);
		}
		85% {
			transform: rotate(5deg);
		}
		95% {
			transform: rotate(-5deg);
		}
		100% {
			transform: rotate(0deg);
		}
	}

	.pulse {
		box-shadow: 0 0 0 0
			rgba(${(props) => (props.textColor ? 'rgb(' + props.textColor + ');' : '0, 0, 0')}, 1);
		transform: scale(1);
		animation-duration: 2.5s;
		animation-timing-function: ease-in-out;
		animation-delay: 0s;
		animation-iteration-count: 2;
		animation-direction: normal;
		animation-fill-mode: none;
		animation-play-state: running;
		animation-name: pulse;

		&:hover,
		&:focus,
		&:active {
			animation: none;
		}
	}

	@keyframes pulse {
		0% {
			transform: scale(0.98);
			box-shadow: 0 0 0 0 rgba(${(props) => (props.textColor ? props.textColor : '0, 0, 0')}, 0.7);
		}

		70% {
			transform: scale(1);
			box-shadow: 0 0 0 10px rgba(${(props) => (props.textColor ? props.textColor : '0, 0, 0')}, 0);
		}

		100% {
			transform: scale(0.98);
			box-shadow: 0 0 0 0 rgba(${(props) => (props.textColor ? props.textColor : '0, 0, 0')}, 0);
		}
	}

	${(props) =>
		props.isPreview &&
		`
		padding-bottom: 0;
		
		#slp-cookieConsent {
			position: sticky;
			z-index: 1;
		}
		#slp-background-media,
		.modal,
		.modal-backdrop {
			position: absolute;
		}
	`}
`;

const StyledBackgroundVideoWrapper = styled.div`
	position: absolute;
	top: 0;
	// left: 0;
	// width: 100%;
	height: 100%;
	pointer-events: none;
	width: 300%;
	left: -100%;

	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
		// height: 100%;
		// left: 50%;
		// width: ${(props) => props.videoAspectRatio * 100}%;
		// margin-left: -${(props) => (props.videoAspectRatio * 100) / 2}%;
		// position: absolute;
		// top: 0;
		// bottom: 0;
	}
`;
